function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.792 23.642C9.785 21.853 11.521 21.306 11 22c-1.372 1.829-2.273 3.187-2.704 4.076 1.399 1.102 3.095 2.114 5.11 3.01l-.812 1.828C4.569 27.347 1 21.857 1 16c0-5.105 2.308-9.297 6.393-12.002 2.372-1.571 5.274-2.59 8.483-2.99l1.117-.14L17 1.994c.007 1.1.007 1.98.002 3.958l-.001.717v.235c6.65-.394 10.717 3.415 10.985 8.551l2.344 1.563a1.5 1.5 0 0 1 .668 1.271c-.11 7.087-4.303 10.415-12.088 9.707l.18-1.992c5.72.52 8.843-1.231 9.679-5.428A1.996 1.996 0 0 1 28 19v-1.131l-2-1.334V16c0-4.517-3.537-7.8-9.877-7.008L15 9.132V8c0-.402 0-.82.002-1.335l.001-.717c.003-1.264.004-2.077.003-2.786-2.464.44-4.677 1.29-6.507 2.503C4.966 8.005 3 11.575 3 16c0 .294.01.587.032.878 5.382-1.658 7.705-2.218 6.968-1.68-2.55 1.861-4.51 3.802-5.88 5.82.428.904.983 1.781 1.672 2.624zM22 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM13 6v3H8c1.333-2 3-3 5-3z"
});

var SvgCat = function SvgCat(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "3c1cd8b03d3de0b2189b7f5632afcf82.svg";
export { SvgCat as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/cat.svg
// module id = null
// module chunks = 